module.exports = __webpack_public_path__ + "static/media/20170806_27day_1391AT.488b0621.jpg";